import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ToggleButtonGroup, ToggleButton } from "react-bootstrap";
import Heading from '../heading/Heading';
import { routerUtil } from "../../util/routerUtil";
import { connect } from "react-redux";
import ducks from '../../ducks'; // const errorOperations = ducks.error.operations;
// const headlessOperations = ducks.headless.operations;

var mobileHeaderOperations = ducks.mobileHeader.operations;

var EatCaterToggle = function EatCaterToggle(props) {
  var history = useHistory();
  var location = useLocation(); // const state = props.store.getState();
  // console.log('EATCATERTOGGLE ',props,state)

  var routeInfo = routerUtil.getCurrentRouteInfo(location);
  var isAEatRoute = routeInfo.isAEatRoute,
      isACaterRoute = routeInfo.isACaterRoute,
      isAShopRoute = routeInfo.isAShopRoute,
      segments = routeInfo.segments,
      isCaterLandingPage = routeInfo.isCaterLandingPage,
      isEatLandingPage = routeInfo.isEatLandingPage,
      isCategoryPage = routeInfo.isCategoryPage,
      lastUrlSegment = routeInfo.lastUrlSegment;
  var fontSize = "5em";
  var eatValue = "EAT";
  var caterValue = "CATER"; // const foodCategory = props?.mobileHeader?.foodCategory;

  var foodCategory = isAEatRoute ? eatValue : isACaterRoute ? caterValue : undefined;

  var handleToggleChange = function handleToggleChange(newValue) {
    if (newValue == eatValue) {
      history.push("/menu");
    } else {
      history.push("/" + newValue);
    }

    props.setFoodCategory(newValue);
  };

  var getButtonStyle = function getButtonStyle(isActive) {
    if (isActive) {
      return "cb-font-veneer cb-bg-color-brown-500 white border-0";
    }

    return "cb-font-veneer cb-color-brown-500 bg-white border-0";
  };

  return (
    /*#__PURE__*/
    // <ReactReduxContext.Consumer>
    // {(context => (
    React.createElement(ToggleButtonGroup, {
      type: "radio",
      name: "options",
      onChange: handleToggleChange,
      defaultValue: foodCategory
    }, /*#__PURE__*/React.createElement(ToggleButton, {
      value: eatValue,
      style: {
        width: fontSize
      },
      className: getButtonStyle(foodCategory == eatValue)
    }, eatValue), /*#__PURE__*/React.createElement(ToggleButton, {
      style: {
        width: fontSize
      },
      className: getButtonStyle(foodCategory == caterValue),
      value: caterValue
    }, caterValue)) //   )).bind(this)}
    // </ReactReduxContext.Consumer>

  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    mobileHeader: state.mobileHeader,
    menu: state.menu
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setFoodCategory: function setFoodCategory(foodCategory) {
      return dispatch(mobileHeaderOperations.setFoodCategory(foodCategory));
    },
    performHeadlessLayoutFetch: function performHeadlessLayoutFetch(route) {
      return dispatch(headlessOperations.performHeadlessLayoutFetch(route));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EatCaterToggle);